"use strict";

define('rs/models/lock',['rs/models/abstract', 'rs/helper', 'rs/errors'], function (Model, helper, RSError) {
  var AbstractLockModel = Model.extend({
    properties: ['domainId', 'lockMap'],
    initialize: function initialize(domainId) {
      this.setDomainId(domainId);
      this.setLockMap({});
      this._lockPromiseMap = {};
    },
    _requestLocksForDomain: function _requestLocksForDomain(domainId) {},
    _requestLock: function _requestLock(objectId) {},
    _requestUnlock: function _requestUnlock(objectId) {},
    _lockIsOwned: function _lockIsOwned(lockObj) {
      return false;
    },
    _getObjectIdFromLock: function _getObjectIdFromLock(lockObj) {
      return {};
    },
    setLockForDomain: function setLockForDomain(objectId, lockObj) {
      this.getLockMap()[objectId] = lockObj;
    },
    getLockForDomain: function getLockForDomain(objectId) {
      return this.getLockMap()[objectId];
    },
    isLocked: function isLocked(objectId) {
      var locked = false;
      return this.getLock(objectId).then(function (lockObj) {
        locked = !!lockObj;
      }).caught(function () {}).then(function () {
        return locked;
      });
    },
    isLockedSync: function isLockedSync(objectId) {
      return !!this.getLockForDomain(objectId);
    },
    isOwnedSync: function isOwnedSync(objectId) {
      if (this.isLockedSync(objectId)) {
        return this._lockIsOwned(this.getLockForDomain(objectId));
      }
    },
    ownLock: function ownLock(objectId) {
      return this.getLock(objectId).bind(this).then(function (lockObj) {
        return lockObj && this._lockIsOwned(lockObj);
      });
    },
    setLock: function setLock(objectId) {
      if (this._lockPromiseMap[objectId]) {
        return this._lockPromiseMap[objectId];
      }
      var promise = this.ownLock(objectId).bind(this).then(function (isOwned) {
        if (isOwned) {
          return Promise.resolve();
        }
        return this.isLocked(objectId).bind(this).then(function (isLocked) {
          if (isLocked) {
            throw RSError.DomainIsLocked();
          }
        }).then(function () {
          return this._requestLock(objectId);
        }).caught(RSError.APIError, RSError.DomainIsLocked, function (e) {
          return this.updateLockList().then(function () {
            var existingLock = this.getLockForDomain(objectId),
              meesage = null;
            if (e instanceof RSError.APIError && e.getCode() != 'CANNOT_SET_LOCK') {
              throw e;
            }
            if (existingLock) {
              message = 'Your changes have not been applied.  This section is currently being edited by ' + existingLock.updateUser + '.';
            } else {
              message = 'Permission to edit this section could not be obtained.';
            }
            throw RSError.DomainIsLocked(message);
          });
        }).tap(function (lockObj) {
          this.trigger('receivedLock', lockObj);
          this.setLockForDomain(objectId, lockObj);
        });
      }).lastly(function () {
        this._lockPromiseMap[objectId] = null;
      });
      this._lockPromiseMap[objectId] = promise;
      return promise;
    },
    getLock: function getLock(objectId) {
      return Promise.resolve(this._lockListUpdate).bind(this).then(function () {
        return this.getLockForDomain(objectId);
      });
    },
    releaseLock: function releaseLock(objectId) {
      return this.ownLock(objectId).bind(this).then(function (isOwned) {
        if (isOwned) {
          return this._requestUnlock(objectId).bind(this).then(function () {
            this.trigger('releaseLock', this.getLockMap()[objectId]);
            this.getLockMap()[objectId] = undefined;
          });
        }
      });
    },
    updateLockList: function updateLockList() {
      this.setLockMap({});
      return this._lockListUpdate = this._requestLocksForDomain(this.getDomainId()).bind(this).then(function (lockList) {
        this._lockListUpdate = null;
        var objectId;
        for (var i = 0, len = lockList.length; i < len; i++) {
          objectId = this._getObjectIdFromLock(lockList[i]);
          this.setLockForDomain(objectId, lockList[i]);
        }
        this.trigger('updatelist');
      }).lastly(function () {
        this._lockListUpdate = null;
      });
    },
    setup: function setup() {
      return this.updateLockList();
    }
  }, {});
  return AbstractLockModel;
});

